import { FieldNames } from 'v2/core/entities/fields';
import { LabelType } from 'v2/core/entities/taxonomy';
import {
  EmptyWhereClause,
  OperationType,
} from 'v2/core/services/queryBuilder/whereClause';
import { getWhereClauseForFieldName } from 'v2/core/services/queryBuilder/whereClauseGenerator';
import { INPUT_SEARCH_TYPE, SearchQuery } from '../types';

export function toWhereClauseFromBaseCondition(
  baseCondition?: SearchQuery['baseCondition'],
) {
  if (!baseCondition || baseCondition.type === INPUT_SEARCH_TYPE.ADVANCED) {
    return EmptyWhereClause;
  }

  if (baseCondition.type === null) {
    return {
      filter: {
        hybridSearchFilter: {
          query: baseCondition.id,
        },
      },
    };
  }

  const fieldName =
    baseCondition.type === LabelType.Reason
      ? FieldNames.Reason
      : FieldNames.Entity;

  return getWhereClauseForFieldName({
    fieldName,
    values: [baseCondition.id],
    op: OperationType.AND,
  });
}
